<template lang="pug">
modal.input-text-settings-modal(
  :close-button-label='$t("button.cancel")'
  :disable-process-button='invalidForm'
  :process-button-label='$t("button.save")'
  :title='$t("modal.input_text_settings.title")'
  @opened='onOpenModal'
  @process='process'
  ref='modal'
  size='sm'
)
  .col-12(v-if='element')
    form.needs-validation(novalidate)
      .form-group
        label.mb-3(for='field-text-name')
          | {{ $t('modal.input_text_settings.instruction') }}
        .form-control-icon
          icon(name='text')
          input#field-text-name.form-control(
            :placeholder='$t("modal.input_text_settings.placeholder")'
            @blur='validate'
            @input='validate'
            autocomplete='off'
            maxlength='40'
            required
            type='text'
            v-model='element.title'
          )
        .invalid-feedback {{ $t('modal.input_text_settings.invalid_feedback') }}
      .form-group.mb-1
        .form-check.form-switch
          .d-flex.align-items-center
            input#text-field-required.form-check-input(
              type='checkbox'
              v-model='element.required'
            )
            .ms-3
              label.m-0(for='text-field-required') {{ $t('modal.input_text_settings.required') }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';

export default {
  components: {
    Modal,
    Icon,
  },
  data() {
    return {
      element: {},
      invalidForm: true,
    };
  },
  methods: {
    onOpenModal() {
      this.validate();
      if (!this.element.title) {
        window
          .jQuery('#field-text-name')
          .removeClass('is-valid')
          .removeClass('is-invalid');
      }
    },
    process() {
      this.$emit('settings', this.element);
      this.$refs.modal.close();
    },
    validate() {
      if (this.element.title) {
        this.invalidForm = false;
      } else {
        this.invalidForm = true;
      }
    },
  },
};
</script>
<style lang="stylus">
.input-text-settings-modal
  .checkbox-settings-modal
    .form-check.form-switch
      .form-check-label
        margin: .2rem 0 0 .5rem
</style>
